import { render } from "./VomsSummarySection.vue?vue&type=template&id=3ff11a64"
import script from "./VomsSummarySection.vue?vue&type=script&lang=js"
export * from "./VomsSummarySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__